import {getAPIGatewayDataFromParent} from "../handlers/ParentDataHandler";
import {getStationCode} from "../utils/Helper";

export const getTasks = () => {
  const request = getTaskAPIGatewayRequest(
    "/getTasks",
    {nodeId : getStationCode()}
  );
  return getAPIGatewayDataFromParent(request);
};

export const getTaskCounts = (startTime) => {
  const request = getTaskAPIGatewayRequest(
    "/getTaskCounts",
    {
      nodeId : getStationCode(),
      filter : {startTime}
    }
  );
  return getAPIGatewayDataFromParent(request);
}

export const getTaskById = (taskId) => {
  const request = getTaskAPIGatewayRequest(
    "/getTask",
    {taskId}
  );
  return getAPIGatewayDataFromParent(request);
}

export const updateTaskStatus = (taskId, status) => {
  const request = getTaskAPIGatewayRequest(
    "/updateTaskStatus",
    {taskId, status}
  );
  return getAPIGatewayDataFromParent(request);
}

export const addNoteForTask = (taskId, note, metadata) => {
  const request = getTaskAPIGatewayRequest(
    "/addNoteForTask",
    {
      taskId: taskId,
      note: note,
      metadata: metadata
    }
  );
  return getAPIGatewayDataFromParent(request);
}

function getTaskAPIGatewayRequest(resourcePath, requestBody) {
  return {
    resourcePath,
    httpMethod: "post",
    processName: "workItemVisibilityService",
    requestBody
  };
}


// WEBPACK FOOTER //
// ./src/apis/TaskApi.js